import type {VoidFunctionComponent} from 'react';
import {useIntl} from 'react-intl';

import {InfoOutlineIcon} from '../../../../icons/info-outline';

import type {Props} from './types';
import styles from './styles.module.css';

export const EmptyState: VoidFunctionComponent<Props> = ({query = ''}) => {
    const intl = useIntl();

    return (
        <div className={styles.wrapper}>
            <div className={styles.icon}>
                <InfoOutlineIcon width={16} height={16} />
            </div>
            <p className={styles.meta}>
                <span>
                    {intl.formatMessage(
                        {
                            id: 'multiselect.list.notFound',
                            defaultMessage: 'No results found matching {searchQuery}',
                        },
                        {searchQuery: <strong>{query}</strong>},
                    )}
                </span>
            </p>
        </div>
    );
};
